import { Cover, GlassesRenderingOptions, initRenderingOptions } from "types"
import { createGlassesCustomZipEffect } from "utils/zipEffectFileReader"
import { Effect } from "@banuba/webar"
import { applyEffect } from "./player"

let currentEffect: Effect | null = null
let glassesRenderingOptions: GlassesRenderingOptions = initRenderingOptions
const defaultScale = { x: 1, y: 1, z: 1 }
const defaultPosition = { x: 0, y: 2, z: 5 }

export const applyGlassesZipEffect = async (zipEffect: Blob) => {
  const effect = new Effect(zipEffect)
  currentEffect = effect

  await applyEffect(effect)
  await updateGlassesRenderingOptions()
}

export const resetGlasses = async () => {
  await setGlassesPosition(defaultPosition.x, defaultPosition.y, defaultPosition.z)
  await setGlassesScale(defaultScale.x, defaultScale.y, defaultScale.z)
  currentEffect = null
}

export const applyCustomGlassesEffect = async ({
  coverLeft,
  coverFront,
  coverRight,
  renderingOptions,
}: {
  coverLeft: Cover
  coverFront: Cover
  coverRight: Cover
  renderingOptions?: GlassesRenderingOptions
}) => {
  if (renderingOptions) glassesRenderingOptions = renderingOptions

  const zipEffect = await createGlassesCustomZipEffect({
    coverLeft,
    coverFront,
    coverRight,
    renderingOptions: glassesRenderingOptions,
  })

  await applyGlassesZipEffect(zipEffect)
}

export const setGlassesRenderingOptions = async (renderingOptions: GlassesRenderingOptions) => {
  glassesRenderingOptions = renderingOptions
  if (renderingOptions.scale) {
    const { x, y, z } = renderingOptions.scale
    await setGlassesScale(x, y, z)
  }
  if (renderingOptions.positionAccuracy) {
    const { x, y, z } = renderingOptions.positionAccuracy
    await setGlassesPosition(x, y, z)
  }
}

export const updateGlassesRenderingOptions = async () => {
  if (glassesRenderingOptions.scale) {
    const { x, y, z } = glassesRenderingOptions.scale
    await setGlassesScale(x, y, z)
  }
  if (glassesRenderingOptions.positionAccuracy) {
    const { x, y, z } = glassesRenderingOptions.positionAccuracy
    await setGlassesPosition(x, y, z)
  }
}

export const setGlassesPosition = async (x: number, y: number, z: number) => {
  if (currentEffect) {
    const positionAccuracy = { x, y, z }
    glassesRenderingOptions = { ...glassesRenderingOptions, positionAccuracy }

    await currentEffect.evalJs(`setTranslation(${x}, ${y}, ${z})`)
  }
}

export const setGlassesScale = async (x: number, y: number, z: number) => {
  if (currentEffect) {
    const scale = { x, y, z }
    glassesRenderingOptions = { ...glassesRenderingOptions, scale }

    await currentEffect.evalJs(`setScale(${x}, ${y}, ${z})`)
  }
}

export const applyCustomGlassesEffectFromUrl = async (_effectUrl: string) => {
  const zipBlob = await fetch(_effectUrl).then((res) => res.blob())

  return await applyGlassesZipEffect(zipBlob)
}
